import React, { Component } from "react";
import Footer from "../../DiagnosticOrder/DiagnosticTranscription/Footer";

export default class IgssReport extends Component {
  componentWillUnmount() {
      this.props.resetStore();
  }

  componentWillMount() {
      if (this.props.match.params.id) {
          this.props.getIgssForm(this.props.match.params.id);
      }      
  }
  
  render(){    
    const handlePrint = () => {      
      window.print();      
      window.close();
    };    

    const getDate = () => {
      const hoy = new Date();
      const dia = String(hoy.getDate()).padStart(2, '0');
      const mes = String(hoy.getMonth() + 1).padStart(2, '0');
      const año = hoy.getFullYear();      
      return `${dia}/${mes}/${año}`;
    }

    const getTime = () => {
      const ahora = new Date();
      const horas = String(ahora.getHours()).padStart(2, '0');
      const minutos = String(ahora.getMinutes()).padStart(2, '0');
      const segundos = String(ahora.getSeconds()).padStart(2, '0');
      return `${horas}:${minutos}:${segundos}`;
    }

    const {
      igss_form
    } = this.props;

    return(
      <React.Fragment>        
        <div
            className="dont-print"
            style={{
                display: "flex",
                justifyContent: "right",
                margin: "20px 20px 20px 0px",
            }}
        >
            <button
                className="btn btn-primary ml-3 mr-3"
                style={{
                    maxWidth: "100px",
                }}
                //onClick={() => print()}
                onClick={handlePrint}
            >
                IMPRIMIR
            </button>
        </div>
        <div          
          style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "black"
          }}
        >
            <div            
              style={{                  
                  width: "800px",                
                  height: "1024px",
                  backgroundColor: "white",
                  paddingInline: '24px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  boxSizing: 'border-box'
              }}
            >
            <div style={{ paddingInline: '64px' }}>
              <div className="d-flex justify-center mt-5 mb-2">
                    <img
                        style={{ margin: '0 auto' }}
                        src={require("../../../../../assets/img/logo_prolaser_gris.png")}
                        alt="Prolaser_logo"
                        className="logo-transcription"
                    />
              </div>
              <p              
                style={{ textTransform: 'capitalize', textAlign: 'end', marginTop: '50px' ,marginBottom: '125px' }}
              >Quetzaltenango {getDate()}</p>
              
              {igss_form && igss_form.patient &&
                <React.Fragment>
                  <p style={{ textTransform: 'lowercase', marginBottom: '56px'}}><span style={{ textTransform: 'capitalize' }}>A</span> quién interese</p>
                  <p style={{ textTransform: 'lowercase', textAlign: 'justify' }}>
                  <span style={{ textTransform: 'capitalize' }}>Por</span> medio de la presente hacemos de su conocimiento que: <b style={{ textTransform: 'uppercase'}}>{ igss_form.patient.first_name} {igss_form.patient.last_name}</b>, quien se identifica con numero de DPI: {igss_form.patient.dpi}, asistió el día de hoy a CITA de OFTALMOLOGIA por servicios contratados a nuestras instalaciones clínicas, finalizando a las {getTime()}.
                  </p>
                </React.Fragment>
              }
              <p style={{ textTransform: 'lowercase'}}>
              <span style={{ textTransform: 'capitalize' }}>Cualquier</span> duda o consulta por favor comunicarse a los números, 42203735,7736-8712, 7767 6590.              
              </p>

              <p style={{marginTop: '55px', marginBottom: '75px', textTransform: 'capitalize' }}>
              Atentamente:
              </p>

              <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                <img
                    style={{ margin: '0 auto' }}
                    src={require("../../../../../assets/img/sing-cb.png")}
                    alt="Prolaser_logo"
                    className="logo-transcription"
                />
              </div>
              <p style={{ textTransform: 'capitalize', textAlign: 'center' }}>
                Lic. Carlos Barrios <br />
                Administrador <br />
                Prolaser Guatemala, S.A.
              </p>

            </div>            
            <Footer />
          </div>
        </div>
      </React.Fragment>
    );
  }
}